import CrudRequest from '@rootCommon/services/crud-request';
import { FHQ_USERS } from '@rootCommon/constants/end-points';
import { FhqUserListItem, FhqUserListItemDto } from '@rootCommon/types/fhq';
import { BaseEntity, EntityDateInfo, IdType } from '@rootCommon/types/common';
import { ADMIN } from '@rootCommon/constants/common';

const FHQ_USERS_ADMIN = `${FHQ_USERS}/${ADMIN}`;
const FHQ_USERS_ALL_ADMIN = `${FHQ_USERS}/all/${ADMIN}`;

class FhqInvitationSettings extends CrudRequest<BaseEntity & EntityDateInfo, FhqUserListItemDto> {
  constructor() {
    super(FHQ_USERS_ADMIN);
  }

  getBySiteFhqId = async (siteFhqId: IdType): Promise<{ siteFhqId: IdType; users: FhqUserListItem[] }> => {
    const res = await CrudRequest.get<FhqUserListItem[]>(FHQ_USERS_ALL_ADMIN, {
      params: { siteFhqId },
    });

    return { siteFhqId, users: res.data };
  };
}

export default new FhqInvitationSettings();
